module.exports = __webpack_public_path__ + "static/media/lw_calibration.3baee2fd.svg";